<!--
 * @Author: 曹捷
 * @Date: 2020-04-30 08:36:29
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-11 14:22:46
 * @Description: file content
 -->
<template >
  <a-layout class="app-main" :class="{'h100':sysConfig.breadcrumb.fixed , 'app-table-fixed':sysConfig.table.fixed}">
    <a-layout-header :style="{height:'46px'}" v-if="meta.headMenu !==false">
      <bodyTabMenuVue type="mainApp"></bodyTabMenuVue>
    </a-layout-header>
    <a-layout-content :class="{'scrollBar':sysConfig.breadcrumb.fixed}">
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component :is="Component" :key="route.path" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <component :is="Component" :key="route.path" v-if="!$route.meta.keepAlive" />
      </router-view>
    </a-layout-content>
  </a-layout>

</template>

<script>
// import { Layout } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import bodyTabMenuVue from './bodyTabMenu.vue'

export default {
  name: 'AppMain',
  components: {
    bodyTabMenuVue
    // ,ALayout:Layout,ALayoutHeader:Layout.Header, ALayoutContent:Layout.Content 
  },
  data () {
    return {
      config: {}
    }
  },
  computed: {
    ...mapGetters('settings', ['sysConfig']),
    key () {
      return this.$route.path
    },
    meta () {
      return this.$route.meta
    }
  }
}
</script>

<style   lang="less">
.scrollBar() {
  overflow: auto;
  &::-webkit-scrollbar-track-piece {
    background: #d3dce6;
  }

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #99a9bf;
    border-radius: 20px;
  }
}

.main-bread {
  padding-left: 16px;
}
.app-table-fixed {
  height: 100%;
  .obit-main {
    height: calc(100% - 20px);
    .scrollBar();
    display: flex;
    flex-direction: column;
    .obit-content {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      .ant-table-wrapper {
        flex: 1;
        min-height: 0;
        overflow: auto;
        .scrollBar();
      }
    }
  }
}
</style>

